import { ToggleButton, ToggleButtonProps } from "@mui/material";
import { ReactElement } from "react";
import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

type TRideTabsToggleButtonProps = Omit<ToggleButtonProps, "size">;

export const RideBookingsRouteMismatchTooltipStyled = styled.span.attrs<IStyledAttributes>(
  {
    "data-e2e": "ride-bookings-route-mismatch-tooltip",
  },
)`
  display: inline;
  max-width: 420px;
  text-align: start;
  font-size: 11px;
  line-height: 1.35;
  white-space: normal;
`;

export const RideTabsToggleButton = ({
  ...props
}: TRideTabsToggleButtonProps): ReactElement => {
  return <ToggleButton {...props} size="small" />;
};
